import { useBoolean } from '@laxmimanogna/code-quick-components';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { EyeAvatarIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';

function FileViewAction({ auditUpload, chart_id=null }) {
  const [isFileOpen, ifoState] = useBoolean(false);
  const { attachment } = useAuditReportAttachment({ chartId: chart_id });
  return (
    <>
      <EyeAvatarIcon style={{ cursor: 'pointer',width: 45, height: 45 }} onClick={ifoState.on} />
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditUpload?.file_obj}
        attachments={[
          ...(auditUpload?.attachments || []),
          ...(attachment ? [attachment] : [])
        ]}
        onClose={ifoState.off}
      />
    </>
  );
}

export default FileViewAction;
